module.exports = __webpack_public_path__ + "assets/discount_disabled-1c6cf7.svg";